function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#4cbac0",
  d: "M12.3 4.4h-10C1.4 4.4.7 5.1.7 6v11.7h1.7V6h10l-.1-1.6zm-.8 3.3l5 5V21c0 .9-.7 1.7-1.7 1.7H5.7c-1 0-1.7-.8-1.7-1.7V9.4c0-.9.7-1.7 1.7-1.7h5.8zm-.8 5.8h4.6L10.7 9v4.5zm7.9-12.2c-2.3 0-4.3 1.9-4.3 4.3s1.9 4.3 4.3 4.3c2.3 0 4.3-1.9 4.3-4.3S21 1.3 18.6 1.3zm1.6 6.5l-1.6-1-1.6 1 .5-1.9L16 4.7l1.9-.1.7-1.8.7 1.8 1.9.1-1.5 1.2.5 1.9z"
});

var SvgIconFreeDoc = function SvgIconFreeDoc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconFreeDoc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-free-doc.d76ec429.svg";
export { ForwardRef as ReactComponent };